import { ArrowLeft } from "lucide-react";
import Badge from "@/components/shared/ui/Badge";

interface ProjectOverviewProps {
  name: string;
  tagline?: string;
  thumbnail?: string;
  stage?: string;
  accessLevel: "visible" | "locked";
  onBack?: () => void;
}

export default function ProjectOverview({
  name,
  tagline,
  thumbnail,
  stage,
  accessLevel,
  onBack,
}: ProjectOverviewProps) {
  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      window.history.back();
    }
  };

  return (
    <div className="bg-white border-b-2 border-black p-4 sm:p-6">
      <button
        onClick={handleBack}
        className="flex items-center gap-2 text-black hover:underline mb-4 font-bold text-sm sm:text-base"
      >
        <ArrowLeft className="w-4 h-4 sm:w-5 sm:h-5" />
        Back to Dashboard
      </button>

      <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4">
        <div className="flex items-start gap-3 sm:gap-4">
          <div className="text-4xl sm:text-6xl flex-shrink-0">
            {thumbnail || "📁"}
          </div>
          <div className="min-w-0 flex-1">
            <h1 className="text-2xl sm:text-3xl font-bold text-black break-words">
              {name}
            </h1>
            {tagline && (
              <p className="text-sm sm:text-base text-gray-600 mt-1 break-words">
                {tagline}
              </p>
            )}
            <div className="flex flex-wrap gap-2 sm:gap-3 mt-3">
              {stage && (
                <span className="px-2 sm:px-3 py-1 bg-gradient-to-r from-blue-400 to-purple-600 text-white rounded text-xs sm:text-sm font-bold">
                  {stage}
                </span>
              )}
              <Badge
                variant={accessLevel === "visible" ? "success" : "warning"}
                size="sm"
              >
                {accessLevel === "visible" ? "Full Access" : "Limited Access"}
              </Badge>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
